import DataGrid, { Column, Editing, FilterRow, Lookup, Paging, RequiredRule, SearchPanel } from 'devextreme-react/data-grid';
import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Card, CardBody } from 'reactstrap';
import { useAuth } from '../../../auth';
import Breadcrumb from '../../../components/common/breadcrumb';
import { getVessels, saveVessel } from '../../devir-teslim/api';

// Tanımlamalar > Gemiler: vessels are defined here first and then picked when a voyage is planned (no free-text vessel
// names). The operator is a company with the role 'Armatör / denizyolu taşıyıcı' (Tanımlamalar > Firmalar). Each
// vessel is also a custody place: "on board M/V Neptune, Grimaldi" is a step of the chain.
// Role group 'Tanımlamalar - Gemiler' (032_vessels_voyages.sql).
const ROLE_GROUP = 38;

const Gemiler = () => {
    const { hasRole } = useAuth(ROLE_GROUP);
    const canEdit = hasRole('gemi_tanim_write');
    const [md, setMd] = useState({ vessels: [], shipping_lines: [] });
    const load = useCallback(() => getVessels().then(setMd).catch((e) => toast.error(e?.response?.data?.error || 'Gemiler alınamadı')), []);
    useEffect(() => { load(); }, [load]);
    const persist = (row) => saveVessel({
        id: row.id || 0, name: row.name || '', imo_no: row.imo_no || '', operator_party_id: row.operator_party_id || 0,
        flag: row.flag || '', car_capacity: Number(row.car_capacity) || 0, built_year: Number(row.built_year) || 0,
        is_active: row.is_active !== false,
    })
        .then(() => { toast.success('Kaydedildi'); load(); return false; })
        .catch((e) => { toast.error(e?.response?.data?.error || 'Kaydedilemedi'); return true; });
    return (
        <>
            <Breadcrumb parent="Tanımlamalar" current="Gemiler" />
            <Card><CardBody>
                <div className="text-muted mb-2">
                    Gemi önce burada tanımlanır, sefer planlanırken listeden seçilir. İşletmeci, <Link to="/tanimlamalar/firmalar">Firmalar</Link>'da
                    {' '}<b>Armatör / denizyolu taşıyıcı</b> rolü olan firmalardan seçilir (listede yoksa önce orada ekleyin).
                    <br />Hazır liste: Wikidata'daki araç taşıyıcı gemiler (IMO, bayrak, yapım yılı). İşletmeci Wikidata'da yoksa hattın
                    isim kalıbından alındı (Grande → Grimaldi, Morning → EUKOR …). Satış, isim değişikliği, hurda gemilere yansımamış olabilir;
                    kullanmadan önce kontrol edin, kullanılmayanı pasif yapın.
                </div>
                <DataGrid dataSource={md.vessels} keyExpr="id" showBorders columnAutoWidth wordWrapEnabled
                    onRowUpdating={(e) => { e.cancel = persist({ ...e.oldData, ...e.newData }); }}
                    onRowInserting={(e) => { e.cancel = persist({ ...e.data, id: 0 }); }}
                    onInitNewRow={(e) => { e.data.is_active = true; }}>
                    <Editing mode="row" allowUpdating={canEdit} allowAdding={canEdit} />
                    <Paging pageSize={25} />
                    <FilterRow visible />
                    <SearchPanel visible />
                    <Column dataField="name" caption="Gemi adı"><RequiredRule /></Column>
                    <Column dataField="imo_no" caption="IMO no" width={110} />
                    <Column dataField="operator_party_id" caption="İşletmeci (armatör)">
                        <Lookup dataSource={md.shipping_lines} valueExpr="id" displayExpr="name" />
                        <RequiredRule />
                    </Column>
                    <Column dataField="flag" caption="Bayrak" width={80} />
                    <Column dataField="car_capacity" caption="Araç kapasitesi" dataType="number" width={130} />
                    <Column dataField="built_year" caption="Yapım yılı" dataType="number" width={100} />
                    <Column dataField="voyages" caption="Sefer" dataType="number" width={80} allowEditing={false} />
                    <Column dataField="source" caption="Kaynak" allowEditing={false}
                        cellRender={(c) => (c.value ? `${c.value}${c.data.operator_basis ? ` · işletmeci: ${c.data.operator_basis}` : ''}` : 'ekrandan')} />
                    <Column dataField="is_active" caption="Aktif" dataType="boolean" width={80} />
                </DataGrid>
            </CardBody></Card>
        </>
    );
};

export default Gemiler;
